module.exports = __webpack_public_path__ + "static/barghest-78f46742b4b0648ceac842a29a933cc9.jpeg";